module.exports = __webpack_public_path__ + "img/05_Linear_Schieben-VFCR@2x.e498bb8d.jpg";